import * as io from "io-ts";
import { timestamp, uuid } from "diagnostics-lib/io";
import { withMessage } from "io-ts-types";
import t from "../../../../../i18n";

export const Position = withMessage(
  io.refinement(
    io.tuple([io.number, io.number, io.number, io.number]),
    a => a.length === 4 && a.every(n => typeof n === "number" && n >= 1),
  ),
  () => t("schema.block.position"),
);

export const BlockModel = io.type({
  timestamp,
  dashboardId: uuid,
  id: uuid,
  position: Position,
});

export const BlockImport = io.type({
  dashboardId: io.union([uuid, io.undefined]),
  position: io.union([Position, io.undefined]),
});

export type BlockModelT = io.TypeOf<typeof BlockModel>;
